package com.techspiration.webuserapp

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.techspiration.webuserapp.home.HomeScreen
import com.techspiration.webuserapp.legal.LegalScreen
import com.techspiration.webuserapp.legal.PrivacyScreen
import com.techspiration.webuserapp.legal.TermsScreen
import com.techspiration.webuserapp.site.SiteFooter
import com.techspiration.webuserapp.site.SiteNav
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.Main

/**
 * Herkese açık tanıtım sitesinin kök composable'ı: sabit üst nav ([SiteNav]), rotaya göre
 * değişen sayfa gövdesi ([Main] + `when`) ve altbilgi ([SiteFooter]) — bu üçü `.page` sarmalayıcı
 * içinde birleşir. `AboutRoute` ayrı bir sayfa değil; landing'e ([HomeScreen]) düşer.
 */
@Composable
fun App(navigator: UserNavigator = remember { UserNavigator() }) {
    Div(attrs = { classes("page") }) {
        SiteNav(navigator)

        Main {
            when (navigator.current) {
                HomeRoute -> HomeScreen()
                AboutRoute -> HomeScreen()
                PrivacyRoute -> PrivacyScreen()
                TermsRoute -> TermsScreen()
                LegalRoute -> LegalScreen()
            }
        }

        SiteFooter(navigator)
    }
}
